// test691
(691 && 0);
